import $api, {API_URL} from "./instance";
import errorMessage from "../const/Tost";

export const logsService = {
    async getAllWorkers(){
        try{
            return await $api.get(`${API_URL}/user`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    },async getLogs(start,end,id, queryParams){
        try{
            return await $api.get(`${API_URL}/logs?fromDate=${start}&toDate=${end}&userId=${id}${queryParams}`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }
}